import { useMindMapSelector } from './use-mind-map-selector';

/**检测是否已经完全布局了 */
export const useAlreadyLayout = () => {
  return useMindMapSelector((state) => {
    return !state.loading;
  });
};
